<template>
  <div class="animate-pulse">
    <DateSelectorCardSkeleton />

    <div
      class="border-contrast--full relative overflow-hidden rounded-xl bg-white md:h-full"
    >
      <div class="relative md:h-[calc(100%_-_73px)] xs:h-[calc(100%_-_64px)]">
        <div class="md:hidden">
          <div class="h-20 w-full rounded-t-xl bg-neutral-200" />
          <div class="relative flex h-[34.44rem] pt-5">
            <GlobalSchemeLoader class="absolute" />
          </div>
          <div class="h-20 w-full rounded-b-xl bg-neutral-200" />
        </div>
        <div class="!hidden md:!grid">
          <ul
            class="flex flex-wrap md:grid md:grid-cols-1 md:overflow-hidden md:rounded-xl"
          >
            <li
              v-for="(_, index) in new Array(4)"
              :key="index"
              class="border-contrast--full relative mb-4 mr-4 block whitespace-nowrap rounded-xl text-base font-medium text-neutral-600 last:mr-0 md:m-0 md:rounded-none md:!border-0 md:!bg-white md:p-5 md:before:absolute md:before:bottom-0 md:before:left-5 md:before:h-px md:before:w-[calc(100%_-_40px)] md:before:bg-neutral-200 md:before:content-[''] md:last:before:hidden"
            >
              <div class="flex justify-between">
                <div>
                  <div class="mb-3 h-5 w-24 rounded bg-neutral-200" />
                  <div class="flex">
                    <div class="mr-2 h-4 w-16 rounded bg-neutral-200" />
                    <div class="h-4 w-16 rounded bg-neutral-300" />
                  </div>
                </div>
                <div class="h-10 w-28 rounded bg-neutral-300" />
              </div>
            </li>
          </ul>
          <div class="px-5 pb-5">
            <div class="h-10 w-full rounded bg-neutral-200" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>
